import { Injectable } from "@angular/core";
import { BrandLogoDataHeight, BrandLogoDataWidth } from "@common/domain";
import { Store, select } from "@ngrx/store";
import {
  RoomBrandLogoDeferredErrorVO,
  RoomBrandLogoDeleteEventVO,
  RoomBrandLogoSetEventVO,
  RoomBrandLogoCreate1VO,
  RoomBrandLogoCreate2VO,
  RoomBrandLogoDeleteVO,
  RoomBrandLogoUnUseVO,
  RoomBrandLogoUseVO
} from "@youm-front/room/domain";
import { fileImageDimension } from "@youm-front/utils/image";
import { invalidImageFileMessage } from "./invalid-image-file-message";
import { RoomBrandLogoActions } from "../actions";
import { RoomBrandLogoEvents } from "../events";
import { RoomBrandLogoSelectors } from "../selectors";

@Injectable()
export class RoomBrandLogoFacade {
  brandLogo$ = this.store.pipe(select(RoomBrandLogoSelectors.brandLogo));
  isLoading$ = this.store.pipe(select(RoomBrandLogoSelectors.isLoading));

  constructor(private readonly store: Store) {}

  roomBrandLogoDeferredErrorEvent(
    roomBrandLogoDeferredErrorVO: RoomBrandLogoDeferredErrorVO
  ) {
    this.store.dispatch(
      RoomBrandLogoEvents.roomBrandLogoDeferredErrorEvent({
        roomBrandLogoDeferredErrorVO
      })
    );
  }

  roomBrandLogoDeleteEvent(
    roomBrandLogoDeleteEventVO: RoomBrandLogoDeleteEventVO
  ) {
    this.store.dispatch(
      RoomBrandLogoEvents.roomBrandLogoDeleteEvent({
        roomBrandLogoDeleteEventVO
      })
    );
  }

  roomBrandLogoSetEvent(roomBrandLogoSetEventVO: RoomBrandLogoSetEventVO) {
    this.store.dispatch(
      RoomBrandLogoEvents.roomBrandLogoSetEvent({
        roomBrandLogoSetEventVO
      })
    );
  }

  async roomBrandLogoCreate(roomBrandLogoCreate1VO: RoomBrandLogoCreate1VO) {
    let dimension: { width: number; height: number };
    try {
      dimension = await fileImageDimension(roomBrandLogoCreate1VO.value.data);
    } catch {
      this.store.dispatch(
        RoomBrandLogoActions.roomBrandLogoCreateFailure({
          error: invalidImageFileMessage()
        })
      );
      return;
    }
    const { width, height } = dimension;

    const roomBrandLogoCreate2VO = new RoomBrandLogoCreate2VO({
      brandId: roomBrandLogoCreate1VO.value.brandId,
      data: roomBrandLogoCreate1VO.value.data,
      roomId: roomBrandLogoCreate1VO.value.roomId,
      width: width as BrandLogoDataWidth,
      height: height as BrandLogoDataHeight
    });

    this.store.dispatch(
      RoomBrandLogoActions.roomBrandLogoCreate({
        roomBrandLogoCreateVO: roomBrandLogoCreate2VO
      })
    );
  }

  roomBrandLogoDelete(roomBrandLogoDeleteVO: RoomBrandLogoDeleteVO) {
    this.store.dispatch(
      RoomBrandLogoActions.roomBrandLogoDelete({
        roomBrandLogoDeleteVO
      })
    );
  }

  roomBrandLogoUnUse(roomBrandLogoUnUseVO: RoomBrandLogoUnUseVO) {
    this.store.dispatch(
      RoomBrandLogoActions.roomBrandLogoUnUse({
        roomBrandLogoUnUseVO
      })
    );
  }

  roomBrandLogoUse(roomBrandLogoUseVO: RoomBrandLogoUseVO) {
    this.store.dispatch(
      RoomBrandLogoActions.roomBrandLogoUse({
        roomBrandLogoUseVO
      })
    );
  }
}
